import styled from 'styled-components';

export const Tab = styled.section`
  width: 100%;
`;

export const TabList = styled.ul`
  display: block;
  width: 100%;
  border-bottom: 1px solid var(--component-outline-color);
`;

export const TabContent = styled.div`
  margin: 32px auto;
  width: 100%;
`;
